/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { Kpi } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function KpiCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    KpiName: "",
    KpiDescription: "",
    KpiValue: "",
    KpiUnitofMeasure: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [KpiName, setKpiName] = React.useState(initialValues.KpiName);
  const [KpiDescription, setKpiDescription] = React.useState(
    initialValues.KpiDescription
  );
  const [KpiValue, setKpiValue] = React.useState(initialValues.KpiValue);
  const [KpiUnitofMeasure, setKpiUnitofMeasure] = React.useState(
    initialValues.KpiUnitofMeasure
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setKpiName(initialValues.KpiName);
    setKpiDescription(initialValues.KpiDescription);
    setKpiValue(initialValues.KpiValue);
    setKpiUnitofMeasure(initialValues.KpiUnitofMeasure);
    setErrors({});
  };
  const validations = {
    KpiName: [],
    KpiDescription: [],
    KpiValue: [],
    KpiUnitofMeasure: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          KpiName,
          KpiDescription,
          KpiValue,
          KpiUnitofMeasure,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new Kpi(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "KpiCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Key Performance Indicators"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 21c."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Create a record that describes a key performance indicator used to measure and manage climate-related risks and opportunities."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextField
        label="Kpi name"
        isRequired={false}
        isReadOnly={false}
        value={KpiName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              KpiName: value,
              KpiDescription,
              KpiValue,
              KpiUnitofMeasure,
            };
            const result = onChange(modelFields);
            value = result?.KpiName ?? value;
          }
          if (errors.KpiName?.hasError) {
            runValidationTasks("KpiName", value);
          }
          setKpiName(value);
        }}
        onBlur={() => runValidationTasks("KpiName", KpiName)}
        errorMessage={errors.KpiName?.errorMessage}
        hasError={errors.KpiName?.hasError}
        {...getOverrideProps(overrides, "KpiName")}
      ></TextField>
      <TextAreaField
        label="Kpi description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              KpiName,
              KpiDescription: value,
              KpiValue,
              KpiUnitofMeasure,
            };
            const result = onChange(modelFields);
            value = result?.KpiDescription ?? value;
          }
          if (errors.KpiDescription?.hasError) {
            runValidationTasks("KpiDescription", value);
          }
          setKpiDescription(value);
        }}
        onBlur={() => runValidationTasks("KpiDescription", KpiDescription)}
        errorMessage={errors.KpiDescription?.errorMessage}
        hasError={errors.KpiDescription?.hasError}
        	value={KpiDescription} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "KpiDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid6")}
      >
        <TextField
          label="Kpi value"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={KpiValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                KpiName,
                KpiDescription,
                KpiValue: value,
                KpiUnitofMeasure,
              };
              const result = onChange(modelFields);
              value = result?.KpiValue ?? value;
            }
            if (errors.KpiValue?.hasError) {
              runValidationTasks("KpiValue", value);
            }
            setKpiValue(value);
          }}
          onBlur={() => runValidationTasks("KpiValue", KpiValue)}
          errorMessage={errors.KpiValue?.errorMessage}
          hasError={errors.KpiValue?.hasError}
          {...getOverrideProps(overrides, "KpiValue")}
        ></TextField>
        <TextField
          label="Kpi unit of measure"
          isRequired={false}
          isReadOnly={false}
          value={KpiUnitofMeasure}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                KpiName,
                KpiDescription,
                KpiValue,
                KpiUnitofMeasure: value,
              };
              const result = onChange(modelFields);
              value = result?.KpiUnitofMeasure ?? value;
            }
            if (errors.KpiUnitofMeasure?.hasError) {
              runValidationTasks("KpiUnitofMeasure", value);
            }
            setKpiUnitofMeasure(value);
          }}
          onBlur={() =>
            runValidationTasks("KpiUnitofMeasure", KpiUnitofMeasure)
          }
          errorMessage={errors.KpiUnitofMeasure?.errorMessage}
          hasError={errors.KpiUnitofMeasure?.hasError}
          {...getOverrideProps(overrides, "KpiUnitofMeasure")}
        ></TextField>
      </Grid>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
